import { render, staticRenderFns } from "./PaxList.vue?vue&type=template&id=5565ab59&scoped=true&"
import script from "./PaxList.vue?vue&type=script&lang=js&"
export * from "./PaxList.vue?vue&type=script&lang=js&"
import style0 from "./PaxList.vue?vue&type=style&index=0&id=5565ab59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5565ab59",
  null
  
)

export default component.exports